const BLOCKED_PROPERTIES = [
	// Events
	"onload",
	"onbeforeunload",
	"onunload",

	// Mutable properties
	"fullscreen",
	// Maybe someday we will enable this but malicious libraries can call this as long as they do
	// not reference it directly from the cell's code. "localStorage".
	"location",
	"name",
	"opener",
	"navigation",
	"sessionStorage",
	"status",

	// Methods
	// TODO add "alert" back in if needed
	"blur",
	"close",
	"confirm",
	"focus",
	"moveBy",
	"moveTo",
	"open",
	"resizeBy",
	"resizeTo",
	"scroll",
	"scrollBy",
	"scrollByLines",
	"scrollByPages",
	"scrollTo",
	"sizeToContent",
	"stop",

	// Deprecated methods
	"back",
	"captureEvents",
	"forward",
	"releaseEvents",
];

const getBlockedString = (key: string) => `${key} is blocked from use in Moment code cells`;

// Returns a safe window object that blocks access to certain properties
export const getSafeWindow = () => {
	if (typeof window === "undefined") {
		return {};
	}

	const properties = Object.getOwnPropertyDescriptors(window);
	return Object.entries(properties).reduce((acc, [key, value]) => {
		const isBlocked = BLOCKED_PROPERTIES.includes(key);
		Object.defineProperty(acc, key, {
			writable: !isBlocked,
			configurable: !isBlocked,
			enumerable: true,
			value: isBlocked ? getBlockedString(`window.${key}`) : value,
		});
		return acc;
	}, {});
};

// Returns an object with blocked window properties
export const getBlockedWindowProperties = () => {
	const blockedProperties = {};
	for (const key of BLOCKED_PROPERTIES) {
		Object.defineProperty(blockedProperties, key, {
			writable: false,
			configurable: false,
			enumerable: true,
			value: getBlockedString(key),
		});
	}

	return blockedProperties;
};
